import { ReactNode, Ref } from "react";
import "../styles/header.css";

export { Header };

const Header = ({
  ref,
  ...props
}: {
  ref?: Ref<HTMLHeadingElement>;
  children: ReactNode;
}) => {
  return (
    <h3 {...props} ref={ref}>
      {props.children}
    </h3>
  );
};
